/**
 * What stops an offer nagging you is Dismiss, and nothing else.
 *
 * There used to be a "one automatic offer per module per session" budget as
 * well. It produced two separate reports of suggestions silently dying: first
 * it let one Vault offer lock out every other Vault offer for the rest of the
 * session, and once that was keyed per offer instead, it still meant a
 * suggestion you had seen once never came back -- select some files, ignore
 * the offer, and Vault never suggested anything again.
 *
 * An offer already only appears when the page matches it, it disappears the
 * moment that stops being true, Dismiss silences one for the session and the
 * Settings toggle silences all of them. A session-long budget on top of that
 * bought nothing and broke the feature twice.
 */
export const OFFERS_MUTED_KEY = "weco.mochi.offers_muted";
const DISMISS_KEY = "weco:mochi:offer-dismissed";     // sessionStorage, JSON string[]

export function isMuted(): boolean {
  try { return localStorage.getItem(OFFERS_MUTED_KEY) === "1"; } catch { return false; }
}

export function setMuted(v: boolean): void {
  try { v ? localStorage.setItem(OFFERS_MUTED_KEY, "1") : localStorage.removeItem(OFFERS_MUTED_KEY); } catch { /* ignore */ }
}

function readDismissed(): Set<string> {
  try { return new Set(JSON.parse(sessionStorage.getItem(DISMISS_KEY) ?? "[]")); } catch { return new Set(); }
}

export function isDismissed(key: string): boolean { return readDismissed().has(key); }

export function dismissOffer(key: string): void {
  const s = readDismissed(); s.add(key);
  try { sessionStorage.setItem(DISMISS_KEY, JSON.stringify([...s])); } catch { /* ignore */ }
}

export function getDismissed(): Set<string> { return readDismissed(); }
